import { useCallback } from "react"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { getEpisodeOfCareProgressNotesConnectionId } from "@/modules/patients/detail/episode-of-care/lib/get-episode-of-care-connection"
import { Country } from "@/modules/patients/services/__generated__/PatientFragment.graphql"
import {
  Ch_deleteProgressNoteInput,
  chDeleteProgressNoteMutation,
} from "@/modules/patients/services/ch/__generated__/chDeleteProgressNoteMutation.graphql"
import { chDeleteProgressNoteMutation as chMutation } from "@/modules/patients/services/ch/chDeleteProgressNoteMutation"
import {
  De_deleteProgressNoteInput,
  deDeleteProgressNoteMutation,
} from "@/modules/patients/services/de/__generated__/deDeleteProgressNoteMutation.graphql"
import { deDeleteProgressNoteMutation as deMutation } from "@/modules/patients/services/de/deDeleteProgressNoteMutation"

export const useDeleteProgressNoteMutation = (country: Country) => {
  const mutation = country === "CH" ? chMutation : deMutation

  const [commit] = useMutationWithErrorToast<chDeleteProgressNoteMutation & deDeleteProgressNoteMutation>(mutation)

  return useCallback(
    (
      input: De_deleteProgressNoteInput & Ch_deleteProgressNoteInput,
      episodeOfCareId: string | undefined,
      onCompleted?: () => void,
    ) => {
      const connections: string[] = []

      if (episodeOfCareId) {
        connections.push(getEpisodeOfCareProgressNotesConnectionId(episodeOfCareId))
      }

      commit({
        variables: {
          input,
          connections: connections,
        },
        onCompleted(response) {
          const data = response.deleteProgressNote
          if (!data.errors?.length) {
            onCompleted?.()
          }
        },
      })
    },
    [commit],
  )
}
